import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Placeholder,
  Collapse,
  Spinner
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";

import personPlaceholder from "../../assets/images/users/user-dummy-img.jpg";

//Import actions
import {
  getIndividuals as onGetIndividuals,
  deleteIndividual as onDeleteIndividual,
} from "../../slices/thunks";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../Components/Common/TableContainer";

// Export Modal
import ExportCSVModal from "../../Components/Common/ExportCSVModal";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { formatCPF } from "../../utils/formatters";
import { individualsService } from "../../services/individualsService";
import { serviceTypesService } from "../../services/serviceTypesService";

const CrmIndividuals = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const selectLayoutState = (state: any) => state.Crm;
  const crmIndividualsData = createSelector(
    selectLayoutState,
    (state: any) => ({
      individuals: state.individuals,
      isIndividualsSuccess: state.isIndividualsSuccess,
    })
  );

  const { individuals } = useSelector(crmIndividualsData);

  // const [individual, setIndividual] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    dispatch(onGetIndividuals());
  }, [dispatch]);

  useEffect(() => {
    // setIndividual(individuals);
    if (individuals && individuals.length >= 0) {
      setIsLoading(false);
    }
  }, [individuals]);

  useEffect(() => {
    if (!isEmpty(individuals)) {
      // setIndividual(individuals);
      setIsLoading(false);
    }
  }, [individuals]);

  const [detailTab, setDetailTab] = useState<'info' | 'address' | 'services'>('info');
  // const [showSenhaGov, setShowSenhaGov] = useState<{ [key: string]: boolean }>({});
  const [showMore, setShowMore] = useState<boolean>(false);
  const [services, setServices] = useState<any[]>([]);
  const [serviceTypes, setServiceTypes] = useState<any[]>([]);
  const [loadingServices, setLoadingServices] = useState<boolean>(false);
  const [showServiceDetails, setShowServiceDetails] = useState<{ [key: string]: boolean }>({});

  //delete Individual
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);
  const [deleteTarget, setDeleteTarget] = useState<any>(null);

  // Delete Data
  const handleDeleteIndividual = async () => {
    if (!deleteTarget) return;

    try {
      dispatch(onDeleteIndividual(deleteTarget.id));
      setDeleteModal(false);
      setDeleteTarget(null);
    } catch (error: any) {
      toast.error(error.message || t('Erro ao excluir'));
    }
  };

  const onClickDelete = (item: any) => {
    setDeleteTarget(item);
    setDeleteModal(true);
  };

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall: any = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".individualCheckBox");

    if (checkall.checked) {
      ele.forEach((ele: any) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele: any) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState<boolean>(false);

  const deleteMultiple = () => {
    const checkall: any = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element: any) => {
      dispatch(onDeleteIndividual(element.value));
      setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const deleteCheckbox = () => {
    const ele: any = document.querySelectorAll(".individualCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  // Individuals Columns
  const individualsColumns = useMemo(
    () => [
      {
        header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={(e) => { e.stopPropagation(); checkedAll(); }} />,
        cell: (cell: any) => {
          return <input type="checkbox" className="individualCheckBox form-check-input" value={cell.getValue()} onChange={() => deleteCheckbox()} onClick={(e: any) => e.stopPropagation()} />;
        },
        id: '#',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
        enableGlobalFilter: false,
      },
      {
        header: t("Nome"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableGlobalFilter: false,
      },
      {
        header: t("CPF"),
        accessorKey: "cpf",
        enableColumnFilter: false,
        cell: (cell: any) => formatCPF(cell.getValue()),
      },
      {
        header: t("Telefone"),
        accessorKey: "phone",
        enableColumnFilter: false,
        enableGlobalFilter: false,
      },
      {
        header: t("Data de Nascimento"),
        accessorKey: "birthDate",
        enableColumnFilter: false,
        enableGlobalFilter: false,
        cell: (cell: any) => {
          const date = cell.getValue();
          return date ? new Date(date).toLocaleDateString('pt-BR') : '-';
        },
      },
      {
        header: t("Cidade"),
        accessorKey: "address.city",
        enableColumnFilter: false,
        enableGlobalFilter: false,
        cell: (cell: any) => {
          const individual = cell.row.original;
          return individual.address?.city || '-';
        },
      },
      {
        header: t("Tem Serviços"),
        id: "hasServices",
        enableColumnFilter: false,
        enableGlobalFilter: true,
        accessorFn: (row: any) => {
          // Use distinctive keywords that won't fuzzy-match names
          return row.hasServices ? 'COMSERVICOS sim' : 'SEMSERVICOS nao não';
        },
        cell: (cell: any) => {
          const hasServices = cell.row.original.hasServices;
          return hasServices ? (
            <span className="badge bg-success-subtle text-success">
              <i className="ri-check-line me-1"></i>
              Sim
            </span>
          ) : (
            <span className="badge bg-secondary-subtle text-secondary">Não</span>
          );
        },
      },
      {
        header: t("Ação"),
        cell: (cell: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title="View">
                <Link to="#"
                  onClick={(e) => { e.stopPropagation(); const individualData = cell.row.original; setInfo(individualData); }}
                >
                  <i className="ri-eye-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Edit">
                <Link className="edit-item-btn" to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const individualData = cell.row.original;
                    navigate(`/apps-crm-individuals/edit/${individualData.id}`);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Delete">
                <Link
                  className="remove-item-btn"
                  onClick={(e) => { e.stopPropagation(); const individualData = cell.row.original; onClickDelete(individualData); }}
                  to="#"
                >
                  <i className="ri-delete-bin-fill align-bottom text-muted"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [checkedAll, t, navigate]
  );

  // SideBar Individual Detail
  const [info, setInfo] = useState<any>(null);

  // Handle row click to show details
  const handleRowClick = useCallback((rowData: any) => {
    setInfo(rowData);
  }, []);

  // Auto-load first row when data changes
  useEffect(() => {
    if (individuals && individuals.length > 0 && individuals[0]?.id) {
      setInfo(individuals[0]);
    }
  }, [individuals]);

  // Load services when individual is selected
  useEffect(() => {
    const loadServices = async () => {
      if (!info?.id) {
        setServices([]);
        return;
      }

      try {
        setLoadingServices(true);
        const [servicesResult, serviceTypesResult] = await Promise.all([
          individualsService.getServices(info.id),
          serviceTypesService.getAll(true, false)
        ]);
        setServices(servicesResult.services || []);
        setServiceTypes(serviceTypesResult.serviceTypes || []);
      } catch (error) {
        console.error('Error loading services:', error);
        setServices([]);
      } finally {
        setLoadingServices(false);
      }
    };

    loadServices();
  }, [info?.id]);

  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState<boolean>(false);

  // Helper function to find service type name by ID (recursive search through children)
  const findServiceTypeName = useCallback((serviceTypeId: string): string => {
    const searchInTypes = (types: any[]): string | null => {
      for (const type of types) {
        if (type.id === serviceTypeId) return type.name;
        if (type.children && type.children.length > 0) {
          const found = searchInTypes(type.children);
          if (found) return found;
        }
      }
      return null;
    };
    return searchInTypes(serviceTypes) || serviceTypeId;
  }, [serviceTypes]);

  // Helper function to find service type by ID (recursive search through children)
  const findServiceType = useCallback((serviceTypeId: string): any | null => {
    const searchInTypes = (types: any[]): any | null => {
      for (const type of types) {
        if (type.id === serviceTypeId) return type;
        if (type.children && type.children.length > 0) {
          const found = searchInTypes(type.children);
          if (found) return found;
        }
      }
      return null;
    };
    return searchInTypes(serviceTypes);
  }, [serviceTypes]);

  // Helper function to get the price to display (custom price or default price)
  const getServicePrice = useCallback((service: any): number | null => {
    if (service.customPrice) return service.customPrice;
    const serviceType = findServiceType(service.serviceTypeId);
    return serviceType?.defaultPrice || null;
  }, [findServiceType]);

  document.title = "Pessoas Físicas | ProMédico Contabilidade";

  return (
    <React.Fragment>
      <div className="page-content">
        <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={individuals}
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteIndividual}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <Container fluid>
          <BreadCrumb title={t("Pessoas Físicas")} pageTitle={t("CRM")} />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="flex-grow-1">
                      <button className="btn btn-primary add-btn" onClick={() => navigate('/apps-crm-individuals/new')}>
                        <i className="ri-add-fill me-1 align-bottom"></i> {t("Adicionar Pessoa Física")}
                      </button>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2">
                        {isMultiDeleteButton && <button className="btn btn-soft-secondary" id="remove-actions"
                          onClick={() => setDeleteModalMulti(true)}
                        ><i className="ri-delete-bin-2-line"></i></button>}
                        <button className="btn btn-secondary">
                          <i className="ri-filter-2-line me-1 align-bottom"></i>{" "}
                          {t("Filters")}
                        </button>
                        <button className="btn btn-soft-success" onClick={() => setIsExportCSV(true)}>{t("Export")}</button>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            href="#"
                            className="btn btn-soft-info btn-icon"
                            tag="button"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" href="#">
                              {t("All")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Week")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Month")}
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              {t("Last Year")}
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={9}>
              <Card id="individualList">
                <CardHeader className="border-0">
                  <h5 className="card-title mb-0">
                    <i className="ri-user-3-line me-2"></i>
                    {t("Lista de Pessoas Físicas")}
                  </h5>
                </CardHeader>

                <CardBody className="pt-0">
                  <div>
                    {isLoading ? (
                      <div className="py-4">
                        {/* Search bar skeleton */}
                        <div className="mb-3">
                          <Placeholder animation="glow">
                            <Placeholder xs={4} />
                          </Placeholder>
                        </div>
                        {/* Table skeleton */}
                        <div className="table-responsive">
                          <table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={8} size="sm" /></Placeholder></th>
                                <th><Placeholder animation="glow"><Placeholder xs={6} size="sm" /></Placeholder></th>
                              </tr>
                            </thead>
                            <tbody>
                              {[...Array(5)].map((_, i) => (
                                <tr key={i}>
                                  <td><Placeholder animation="glow"><Placeholder xs={10} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={8} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={9} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={7} /></Placeholder></td>
                                  <td><Placeholder animation="glow"><Placeholder xs={4} /></Placeholder></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : Array.isArray(individuals) && individuals.filter((i: any) => i && i.id).length > 0 ? (
                      <TableContainer
                        columns={individualsColumns}
                        data={individuals.filter((i: any) => i && i.id)}
                        isGlobalFilter={true}
                        customPageSize={7}
                        divClass="table-responsive table-card mb-2"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        isCompaniesFilter={true}
                        SearchPlaceholder={t('Buscar pessoa física...')}
                        onRowClick={handleRowClick}
                      />
                    ) : (
                      <div className="noresult">
                        <div className="text-center py-4">
                          <div className="avatar-md mx-auto mb-4">
                            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-24">
                              <i className="ri-user-3-line"></i>
                            </div>
                          </div>
                          <h5 className="mt-2">{t("Sorry! No Result Found")}</h5>
                          <p className="text-muted mb-0">
                            {t("Nenhuma pessoa física encontrada. Clique no botão acima para adicionar.")}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xxl={3}>
              <Card id="individual-view-detail">
                {isLoading ? (
                  <CardBody className="text-center">
                    <div className="position-relative d-inline-block">
                      <Placeholder animation="glow">
                        <Placeholder xs={12} className="avatar-md rounded-circle" style={{ height: '48px' }} />
                      </Placeholder>
                    </div>
                    <div className="mt-3">
                      <Placeholder animation="glow">
                        <Placeholder xs={8} className="mb-2" />
                        <Placeholder xs={6} size="sm" />
                      </Placeholder>
                    </div>
                    <div className="mt-4">
                      <Placeholder animation="glow">
                        <Placeholder xs={12} className="mb-2" />
                        <Placeholder xs={10} className="mb-2" />
                        <Placeholder xs={11} className="mb-2" />
                      </Placeholder>
                    </div>
                  </CardBody>
                ) : (
                  <>
                    <CardBody className="text-center">
                      <div className="position-relative d-inline-block">
                        <div className="avatar-xl">
                          <div className="avatar-title bg-light rounded-circle">
                            <img src={personPlaceholder} alt="" className="avatar-lg rounded-circle" />
                          </div>
                        </div>
                      </div>
                      {info && info.id ? (
                        <>
                          <h5 className="mt-3 mb-1">{info.name}</h5>
                          <p className="text-muted">{formatCPF(info.cpf)}</p>
                        </>
                      ) : (
                        <>
                          <h5 className="mt-3 mb-1">&nbsp;</h5>
                          <p className="text-muted">&nbsp;</p>
                        </>
                      )}
                    </CardBody>
                  </>
                )}

                {info && info.id && (
                  <div className="card-body pt-0">
                    <Nav tabs className="nav-tabs-custom nav-success mb-3">
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={detailTab === 'info' ? 'active' : ''}
                          onClick={() => setDetailTab('info')}
                        >
                          <i className="ri-information-line me-1"></i>
                          {t('Info')}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={detailTab === 'services' ? 'active' : ''}
                          onClick={() => setDetailTab('services')}
                        >
                          <i className="ri-briefcase-line me-1"></i>
                          {t('Serviços')}
                          {services.length > 0 && (
                            <span className="badge bg-success ms-1">{services.length}</span>
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={detailTab === 'address' ? 'active' : ''}
                          onClick={() => setDetailTab('address')}
                        >
                          <i className="ri-map-pin-line me-1"></i>
                          {t('Endereço')}
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent activeTab={detailTab}>
                      <TabPane tabId="info">
                        <div className="table-responsive table-card">
                          <table className="table table-borderless mb-0">
                            <tbody>
                              <tr>
                                <td className="fw-medium">{t("Telefone")}</td>
                                <td>{info.phone || '-'}</td>
                              </tr>
                              <tr>
                                <td className="fw-medium">{t("Email")}</td>
                                <td>{info.email || '-'}</td>
                              </tr>
                              <tr>
                                <td className="fw-medium">{t("RG")}</td>
                                <td>{info.rg || '-'}</td>
                              </tr>
                              <tr>
                                <td className="fw-medium">{t("Data de Nascimento")}</td>
                                <td>{info.birthDate ? new Date(info.birthDate).toLocaleDateString('pt-BR') : '-'}</td>
                              </tr>
                              <tr>
                                <td className="fw-medium">{t("Entidade Profissional")}</td>
                                <td>{info.professionalEntity || '-'}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="mt-3">
                          <Button
                            color="link"
                            className="p-0 text-decoration-none"
                            onClick={() => setShowMore(!showMore)}
                          >
                            {showMore ? (
                              <>
                                <i className="ri-arrow-up-s-line me-1"></i>
                                {t("Mostrar menos")}
                              </>
                            ) : (
                              <>
                                <i className="ri-arrow-down-s-line me-1"></i>
                                {t("Mostrar mais")}
                              </>
                            )}
                          </Button>
                          <Collapse isOpen={showMore}>
                            <div className="table-responsive table-card mt-2">
                              <table className="table table-borderless mb-0">
                                <tbody>
                                  <tr>
                                    <td colSpan={2} className="pb-2">
                                      <h6 className="text-muted text-uppercase fw-semibold mb-0">
                                        <i className="ri-history-line me-1"></i>
                                        {t("Auditoria")}
                                      </h6>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Criado em")}</td>
                                    <td>{info.createdAt ? new Date(info.createdAt).toLocaleString('pt-BR') : '-'}</td>
                                  </tr>
                                  <tr>
                                    <td className="fw-medium">{t("Criado Por")}</td>
                                    <td>{info.createdByName || 'Sistema'}</td>
                                  </tr>
                                  {info.updatedAt && (
                                    <>
                                      <tr>
                                        <td className="fw-medium">{t("Ult. Atualização")}</td>
                                        <td>{new Date(info.updatedAt).toLocaleString('pt-BR')}</td>
                                      </tr>
                                      <tr>
                                        <td className="fw-medium">{t("Ult. Atual. Por")}</td>
                                        <td>{info.updatedByName || 'Sistema'}</td>
                                      </tr>
                                    </>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Collapse>
                        </div>
                      </TabPane>

                      <TabPane tabId="services">
                        {loadingServices ? (
                          <div className="text-center py-4">
                            <Spinner color="primary" size="sm" />
                            <p className="text-muted mt-2 mb-0">{t("Carregando serviços...")}</p>
                          </div>
                        ) : services.length > 0 ? (
                          <div className="table-responsive table-card">
                            <table className="table table-borderless table-sm mb-0">
                              <tbody>
                                {services.map((service) => (
                                  <React.Fragment key={service.id}>
                                    <tr>
                                      <td className="fw-medium" style={{ width: '50%' }}>
                                        {findServiceTypeName(service.serviceTypeId)}
                                      </td>
                                      <td style={{ width: '25%' }}>
                                        <span className={`badge bg-${
                                          service.status === 'ACTIVE' || service.status === 'Active' ? 'success' :
                                          service.status === 'SUSPENDED' || service.status === 'Suspended' ? 'warning' :
                                          service.status === 'COMPLETED' || service.status === 'Completed' ? 'info' :
                                          'secondary'
                                        }-subtle text-${
                                          service.status === 'ACTIVE' || service.status === 'Active' ? 'success' :
                                          service.status === 'SUSPENDED' || service.status === 'Suspended' ? 'warning' :
                                          service.status === 'COMPLETED' || service.status === 'Completed' ? 'info' :
                                          'secondary'
                                        }`}>
                                          {service.status === 'ACTIVE' || service.status === 'Active' ? 'Ativo' :
                                           service.status === 'SUSPENDED' || service.status === 'Suspended' ? 'Suspenso' :
                                           service.status === 'COMPLETED' || service.status === 'Completed' ? 'Concluído' :
                                           'Cancelado'}
                                        </span>
                                      </td>
                                      <td className="text-end" style={{ width: '25%' }}>
                                        {(() => {
                                          const price = getServicePrice(service);
                                          return price ? (
                                            <span className={`fw-medium ${service.customPrice ? 'text-success' : 'text-muted'}`}>
                                              R$ {price.toFixed(2)}
                                            </span>
                                          ) : (
                                            <span className="text-muted">-</span>
                                          );
                                        })()}
                                      </td>
                                    </tr>
                                    {(service.isRecurring || service.notes || service.startDate) && (
                                      <tr>
                                        <td colSpan={3} className="pt-0 pb-2">
                                          <Button
                                            color="link"
                                            size="sm"
                                            className="p-0 text-decoration-none"
                                            onClick={() => setShowServiceDetails(prev => ({
                                              ...prev,
                                              [service.id]: !prev[service.id]
                                            }))}
                                          >
                                            {showServiceDetails[service.id] ? (
                                              <>
                                                <i className="ri-arrow-up-s-line"></i>
                                                {t("Mostrar menos")}
                                              </>
                                            ) : (
                                              <>
                                                <i className="ri-arrow-down-s-line"></i>
                                                {t("Mostrar mais")}
                                              </>
                                            )}
                                          </Button>
                                          <Collapse isOpen={showServiceDetails[service.id]}>
                                            <div className="mt-2 ps-3">
                                              {service.isRecurring && service.recurrenceInterval && (
                                                <p className="text-muted mb-1 small">
                                                  <i className="ri-repeat-line me-1"></i>
                                                  <strong>{t("Recorrência")}:</strong>{' '}
                                                  {service.recurrenceInterval === 'MONTHLY' ? 'Mensal' :
                                                   service.recurrenceInterval === 'QUARTERLY' ? 'Trimestral' : 'Anual'}
                                                </p>
                                              )}
                                              {service.startDate && (
                                                <p className="text-muted mb-1 small">
                                                  <i className="ri-calendar-line me-1"></i>
                                                  <strong>{t("Início")}:</strong>{' '}
                                                  {new Date(service.startDate).toLocaleDateString('pt-BR')}
                                                </p>
                                              )}
                                              {service.endDate && (
                                                <p className="text-muted mb-1 small">
                                                  <i className="ri-calendar-check-line me-1"></i>
                                                  <strong>{t("Término")}:</strong>{' '}
                                                  {new Date(service.endDate).toLocaleDateString('pt-BR')}
                                                </p>
                                              )}
                                              {service.nextDueDate && (
                                                <p className="text-muted mb-1 small">
                                                  <i className="ri-calendar-event-line me-1"></i>
                                                  <strong>{t("Próximo Vencimento")}:</strong>{' '}
                                                  {new Date(service.nextDueDate).toLocaleDateString('pt-BR')}
                                                </p>
                                              )}
                                              {service.notes && (
                                                <p className="text-muted mb-0 small">
                                                  <i className="ri-file-text-line me-1"></i>
                                                  <strong>{t("Observações")}:</strong>{' '}
                                                  {service.notes}
                                                </p>
                                              )}
                                            </div>
                                          </Collapse>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="text-center py-4">
                            <div className="avatar-sm mx-auto mb-3">
                              <div className="avatar-title bg-soft-secondary text-secondary rounded-circle fs-20">
                                <i className="ri-briefcase-line"></i>
                              </div>
                            </div>
                            <p className="text-muted mb-0">{t("Nenhum serviço contratado")}</p>
                          </div>
                        )}
                      </TabPane>

                      <TabPane tabId="address">
                        <div className="table-responsive table-card">
                          <table className="table table-borderless mb-0">
                            <tbody>
                              {info.address ? (
                                <>
                                  {info.address.cep && (
                                    <tr>
                                      <td className="fw-medium">{t("CEP")}</td>
                                      <td>{info.address.cep}</td>
                                    </tr>
                                  )}
                                  {info.address.street && (
                                    <tr>
                                      <td className="fw-medium">{t("Rua")}</td>
                                      <td>{info.address.street}</td>
                                    </tr>
                                  )}
                                  {info.address.number && (
                                    <tr>
                                      <td className="fw-medium">{t("Número")}</td>
                                      <td>{info.address.number}</td>
                                    </tr>
                                  )}
                                  {info.address.complement && (
                                    <tr>
                                      <td className="fw-medium">{t("Complemento")}</td>
                                      <td>{info.address.complement}</td>
                                    </tr>
                                  )}
                                  {info.address.neighborhood && (
                                    <tr>
                                      <td className="fw-medium">{t("Bairro")}</td>
                                      <td>{info.address.neighborhood}</td>
                                    </tr>
                                  )}
                                  {info.address.city && (
                                    <tr>
                                      <td className="fw-medium">{t("Cidade")}</td>
                                      <td>{info.address.city}</td>
                                    </tr>
                                  )}
                                  {info.address.state && (
                                    <tr>
                                      <td className="fw-medium">{t("Estado")}</td>
                                      <td>{info.address.state}</td>
                                    </tr>
                                  )}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan={2} className="text-center text-muted">
                                    {t("Nenhum endereço cadastrado")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CrmIndividuals;
